import { ADVISOR_CARDS_DEFAULTS } from '../../moduleRegistry'

export type TypeLabels = typeof ADVISOR_CARDS_DEFAULTS['typeLabels']
export type CtaLabels = typeof ADVISOR_CARDS_DEFAULTS['ctaLabels']
export type FeeStructureTooltips = typeof ADVISOR_CARDS_DEFAULTS['feeStructureTooltips']

export const getTypeLabel = (property: string | undefined, typeLabels: TypeLabels): string =>
  (property && typeLabels[property as keyof TypeLabels]) ?? property ?? ''

export const parseMiles = (distance: string): number => parseInt(distance.split(' ')[0], 10)

export const formatPhone = (phone: string): string => {
  const digits = phone.replace(/\D/g, '')
  if (digits.length === 10) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
  if (digits.length === 11 && digits[0] === '1') return `${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`
  return phone
}

export const getAdvisorType = (format: string): string => {
  switch (format) {
    case 'network': return 'Advisor Network'
    case 'firm': return 'Enterprise Advisor'
    case 'human': return 'Direct Advisor'
    default: return format
  }
}

export const getFeeStructureMapping = (feeStructure: string, feeStructureTooltips: FeeStructureTooltips): string => {
  const defaultTooltip = feeStructureTooltips.varies
  switch (feeStructure) {
    case 'Hourly': return feeStructureTooltips.hourly
    case 'Commission-based': return feeStructureTooltips.commissionBased
    case 'Asset-based fee': return feeStructureTooltips.assetBased
    case 'Fee and commission': return feeStructureTooltips.feeAndCommission
    case 'Flat fee': return feeStructureTooltips.flatFee
    case 'Varies': return feeStructureTooltips.varies
    case 'Other': return feeStructureTooltips.other
    default: return defaultTooltip
  }
}
